import { DestroyRef, Injectable, inject, signal } from '@angular/core';

/**
 * Reactive viewport breakpoint, matching Tailwind's md breakpoint.
 * Used to switch date-picker and dialog overlays into their mobile
 * presentation on phones.
 */
@Injectable({ providedIn: 'root' })
export class ViewportService {
    private readonly destroyRef = inject(DestroyRef);
    // matchMedia is unavailable in the unit-test DOM
    private readonly query = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 767px)') : null;
    readonly isMobile = signal(this.query?.matches ?? false);

    constructor() {
        const query = this.query;
        if (!query) {
            return;
        }

        const onChange = (event: MediaQueryListEvent) => this.isMobile.set(event.matches);
        query.addEventListener('change', onChange);
        this.destroyRef.onDestroy(() => query.removeEventListener('change', onChange));
    }
}
